export default {"src":"/_next/static/media/tables.80041301.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};